import { render, staticRenderFns } from "./SetTableField.vue?vue&type=template&id=60aaa098&scoped=true"
import script from "./SetTableField.vue?vue&type=script&lang=js"
export * from "./SetTableField.vue?vue&type=script&lang=js"
import style0 from "./SetTableField.vue?vue&type=style&index=0&id=60aaa098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aaa098",
  null
  
)

export default component.exports